/* Display-only references. Native Shopify product/variant/media data stays authoritative. */
(function (host) {
  'use strict';
  var handles = ['sunbrella-canvas-tuscan', 'realbud-1000d-polyester-urethane-coated', 'us-cargo-control-shock-cord-3-16-in-500-ft-spool', 'illusions-tea-rose-floral-fabric', 'fuchsia-gingham-check-fabric-1-8-in-check-20-yd-bolt', 'pink-purple-poly-acetate-iridescent-satin-60-in-wide'];
  function get(handle, supplied) {
    if (handles.indexOf(handle) === -1) return null;
    var map = supplied;
    if (!map && host && host.document) {
      var node = host.document.getElementById('NytarpGeneratedImages');
      try { map = node ? JSON.parse(node.textContent) : {}; } catch (error) { return null; }
    }
    var entry = map && map[handle];
    return entry && typeof entry.url === 'string' && /^https:\/\//.test(entry.url) ? entry : null;
  }
  function image(handle, nativeImage, map) { return get(handle, map) || nativeImage; }
  function applyProduct(section, handle) {
    var entry = get(handle);
    if (!entry || !section) return;
    var main = section.querySelector('.product-featured-img');
    if (!main) return;
    if (main.getAttribute('src') !== entry.url) {
      main.removeAttribute('srcset');
      main.src = entry.url;
    }
    main.alt = entry.alt || 'Generated illustration; approximate reference.';
    main.width = Number(entry.width) || 1200;
    main.height = Number(entry.height) || 900;
    main.style.height = 'auto';
    var photo = section.querySelector('.nytarp-product__featured');
    if (photo) {
      photo.removeAttribute('data-color-photo-missing');
      var missing = photo.querySelector('[data-color-photo-placeholder]');
      if (missing) missing.remove();
      if (photo.hasAttribute('data-zoom')) {
        photo.setAttribute('data-zoom', entry.url);
        if (host.jQuery) host.jQuery(photo).data('zoom', entry.url);
      }
    }
    section.querySelectorAll('img.zoomImg').forEach(function (zoom) { zoom.src = entry.url; zoom.alt = main.alt; });
    var caption = section.querySelector('[data-nytarp-image-caption]');
    if (caption) {
      caption.textContent = entry.caption || 'Generated illustration. Color and pattern are approximate; confirm the actual product before ordering.';
      caption.dataset.generatedCaption = caption.textContent;
      caption.hidden = false;
    }
  }
  function init(scope) {
    var sections = Array.from(scope.querySelectorAll('[data-generated-product-handle]'));
    if (scope.matches && scope.matches('[data-generated-product-handle]')) sections.unshift(scope);
    sections.forEach(function (section) { applyProduct(section, section.dataset.generatedProductHandle); });
  }
  var api = { get: get, image: image, applyProduct: applyProduct, init: init };
  if (typeof module !== 'undefined') module.exports = api;
  if (!host || !host.document) return;
  host.NYTarpGeneratedImages = api;
  if (host.document.readyState === 'loading') host.document.addEventListener('DOMContentLoaded', function () { init(host.document); });
  else init(host.document);
  host.document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})(typeof window === 'undefined' ? null : window);
